<style lang="scss"></style>

<template>
  <div id="modal-remove-campanha" class="modal modal-max-poli fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">ATENÇÃO!</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="card card-block shadow0 m0 pb0">
                <div class="title-block" v-if="campanha">
                  <h3 class="title adasd">
                    Tem certeza que deseja remover a campanha
                    <span
                      class="text-info"
                    >{{ campanha.nome }}</span> ?
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary"
            @click="remover"
            :disabled="enviando"
          >{{ enviando ? "REMOVENDO..." : "SIM" }}</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">NÃO</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showLoading, closeLoading } from '../../../helpers';
import CampanhaService from '../../../services/CampanhaService';

export default {
  name: 'modal-remove-campanha',
  data() {
    return {
      enviando: false,
      campanha: null,
    };
  },
  mounted() {
    // eslint-disable-next-line
    $('#modal-remove-campanha').on('hidden.bs.modal', () => {
      this.clear();
      this.$parent.removeCampanhaId = null;
    });

    if (this.$parent.removeCampanhaId === null) return;

    this.load();
  },
  methods: {
    clear() {
      this.enviando = false;
      this.campanha = null;
    },
    async load() {
      try {
        showLoading();

        if (this.$parent.removeCampanhaId === 0) return;

        this.campanha = await CampanhaService.findById(
          this.$parent.removeCampanhaId,
        );
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();

        // eslint-disable-next-line
        $('#modal-remove-campanha').modal('show');
      }
    },
    async remover() {
      try {
        this.enviando = true;

        showLoading();

        await CampanhaService.remove(this.campanha.id);

        this.$toast.success('Campanha removida com sucesso!');

        this.$emit('reload');

        // eslint-disable-next-line
        $('#modal-remove-campanha').modal('hide');
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();

        this.enviando = false;
      }
    },
  },
};
</script>
